module.exports = __webpack_public_path__ + "img/380320625813653.a738e0d3.jpg";